import RandomNumberGenerator from '../../utils/randomNumberGenerator';

var randomNumberGenerator = new RandomNumberGenerator();

function sortNumber(a, b) {
  return a - b;
}

class LobbyCountHandler {

  getLobbyCounts(min, max, time) {
    var randomAmount = randomNumberGenerator.getRandomInclusive(max - min);
    var lobbyCount = randomAmount + min;

    var timeIncrements = [];
    for (var incrementIndex = 0; incrementIndex < lobbyCount; incrementIndex++) {
      timeIncrements.push(randomNumberGenerator.getRandomInclusive(time));
    }
    timeIncrements.sort(sortNumber);

    return timeIncrements;
  }
}

export default LobbyCountHandler


// WEBPACK FOOTER //
// ./src/components/elimination-lobby/lobbyCountHandler.js